export const WORK_NOT_STARTED = 'NOT_STARTED';
export const WORK_STARTED = 'STARTED';
export const WORK_FINISHED = 'FINISHED';
export const WORK_UNKNOWN = 'UNKNOWN';
export const NETWORK_ALLOWED = 'ALLOWED';
export const NETWORK_DENIED = 'DENIED';
export const NETWORK_UNKNOWN = 'UNKNOWN';

export type WorkState = typeof WORK_NOT_STARTED | typeof WORK_STARTED
  | typeof WORK_FINISHED | typeof WORK_UNKNOWN;
export type WorkNetworkState = typeof NETWORK_ALLOWED | typeof NETWORK_DENIED | typeof NETWORK_UNKNOWN;

export interface WorkTimeStatus {
  businessDay: string;
  workState: WorkState;
  networkState: WorkNetworkState;
  resultCode: string | null;
  loginAt: string | null;
  logoutAt: string | null;
  timeZone: string | null;
  checkedAt: string;
}

export interface WorkTimeErrorPayload {
  businessDay?: string;
  workState?: WorkState;
  networkState?: WorkNetworkState;
  resultCode?: string;
  code?: string;
  loginAt?: string | null;
  logoutAt?: string | null;
  timeZone?: string | null;
  checkedAt?: string;
}

export interface WorkTimeRequestError {
  status?: number;
  name?: string;
  error?: WorkTimeErrorPayload;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/work-time.model.ts